/**
 * FedEx terminal numbers (terminals.code). Required at onboarding: it's how
 * RouteBack knows two companies' terminals are the same building (the
 * mechanic's shop view groups by it). Digits only; leading zeros are kept as
 * typed but ignored when comparing ("0601" = "601").
 */

/** "#0601 " → "0601"; anything that isn't 1–6 digits → null. */
export function cleanTerminalNumber(raw: string): string | null {
  const s = raw.trim().replace(/^#/, '').trim();
  return /^[0-9]{1,6}$/.test(s) ? s : null;
}

/** The value two numbers are compared by ("0601" and "601" match). '' when there's no number. */
export function terminalKey(code: string | null | undefined): string {
  const s = (code ?? '').trim();
  if (!s) return '';
  return s.replace(/^0+(?=\d)/, '');
}

/** "0601 Carol Stream", or just the name when the number is missing. */
export function terminalLabel(t: { name: string; code?: string | null }): string {
  return t.code ? `${t.code} ${t.name}` : t.name;
}

/** The name to save when the owner leaves it blank. */
export function defaultTerminalName(code: string): string {
  return `Terminal ${code}`;
}
